/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayInvoicesResponse
 */
export interface PayInvoicesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PayInvoicesResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayInvoicesResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the PayInvoicesResponse interface.
 */
export function instanceOfPayInvoicesResponse(value: object): value is PayInvoicesResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function PayInvoicesResponseFromJSON(json: any): PayInvoicesResponse {
    return PayInvoicesResponseFromJSONTyped(json, false);
}

export function PayInvoicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayInvoicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

  export function PayInvoicesResponseToJSON(json: any): PayInvoicesResponse {
      return PayInvoicesResponseToJSONTyped(json, false);
  }

  export function PayInvoicesResponseToJSONTyped(value?: PayInvoicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorMessage': value['errorMessage'],
    };
}

